module.exports = __webpack_public_path__ + "img/import.08b503d4.png";